import { useQuery } from '@tanstack/react-query';
import { OperationLog } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { isOperationInProgress } from './useOperations';

// Polls one operation until it ends.
export const useOperation = (
  operationId: string | null,
  { onSuccess }: { onSuccess?: (operation: OperationLog) => void } = {}
) =>
  useQuery({
    queryKey: [
      '@MDH',
      'getOperationApiV2OperationOperationIdGet',
      operationId,
    ] as const,
    queryFn: () =>
      operationId === null
        ? Promise.reject(new Error('No operation to fetch.'))
        : datasetApi.getOperationApiV2OperationOperationIdGet(
            operationId,
            getDatasetRequestConfig()
          ),
    select: res => res.data,
    enabled: operationId !== null,
    refetchInterval: operation =>
      operation === undefined || isOperationInProgress(operation)
        ? 2000
        : false,
    onSuccess,
  });
